import { UIElement } from '../ui-element';
import { Digest } from '../../global/index';
import { Component } from '../../decorators/component.decorator';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDefinitionListTerm
 * @element ui-definition-list-term
 * @classdesc Represents a class for <code>ui-definition-list-term</code> element.
 * Allows to provide simple non-interactive HTML as term content. Avoid interactive or complex elements, limit to non-interactive phrasing HTML content. You can feed a custom ID to this element to get it linked to definition in <code>ui-definition-list-item</code>, or one will be generated automatically.
 * @property {string} [resolvedId] Resolved term id used as aria-labelledby target.
 * @slot
 * @example
 * <ui-definition-list>
 *   <ui-definition-list-item>
 *     <span slot="label">
 *       <ui-definition-list-term>Color</ui-definition-list-term>
 *       <button>Click me</button>
 *     </span>
 *     Green
 *   </ui-definition-list-item>
 * </ui-definition-list>
 */
@Component({
    tag: 'ui-definition-list-term',
})
export class UIDefinitionListTerm extends UIElement {
    /**
     * @type {string}
     */
    get resolvedId(): string {
        return this.getAttribute('id') ?? Digest.randomId();
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.updateElement({
            attributes: {
                id: this.resolvedId,
                role: 'term',
            },
        });
    }
}
